import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { BaseDraggableWidget } from '../Card';
import { BaseList } from '../../Widgets/WidgetBase';
import useAsync from '../../../hooks/useAsync';
import { getModuleFieldsBeta } from '../../../api/modules';
import { getAsset } from '../../../api';
import { useParams } from 'react-router-dom';

const TITLE = 'Asset Details';
const DESCRIPTION = 'Enter description here';
const CATEGORY = 'Asset';

const ASSETS_MODULE_ID = process.env.REACT_APP_MODULE_ID_ASSETS;

const AssetOverview = ({ title, isPreview, ...rest }) => {
	const [query, setQuery] = useState('');

	const navigate = useNavigate();
	const { id } = useParams();

	const [form, setForm] = useState({});

	const { value: item } = useAsync(getAsset, { defaultPayload: { id } });

	const {
		value: moduleFields,
		execute: onRefreshModuleFields,
		status: isLoadingModuleFields,
	} = useAsync(getModuleFieldsBeta, {
		defaultPayload: { id: ASSETS_MODULE_ID },
	});

	useEffect(() => {
		if (item) {
			let itemForm = {};

			moduleFields?.combined?.map((field) => {
				const isDefault = field?.isDefault;

				if (isDefault) {
					if (item[field?.key] || item[`${field?.key}Id`]) {
						itemForm[field?.key] = {
							fieldId: field?.id,
							value:
								item[`${field?.key}_id`] || item[`${field?.key}Id`]
									? item[field?.key]?.name
									: item[field?.key],
						};
					}
				} else {
					const val = item?.custom_attributes?.find(
						(f) => f.attribute_field_id === field.id,
					);
					itemForm[field?.key] = {
						value: val?.backupValue || val?.value,
						fieldId: field.id,
						id: val?.id,
					};
				}
			});

			setForm(itemForm);
		}
	}, [item, moduleFields]);

	if (isPreview) {
		return (
			<BaseDraggableWidget
				title={TITLE}
				category={CATEGORY}
				description={DESCRIPTION}
				{...rest}
				isPreview={true}
			/>
		);
	}

	return (
		<BaseDraggableWidget title={TITLE} {...rest}>
			<BaseList
				items={moduleFields?.combined
					?.filter((field) => field?.label !== 'Tags')
					?.map((field) => ({
						label: field?.label,
						value: form[field?.key]?.value || null,
					}))
					?.filter((field) => field.value)
					?.map((field) => {
						return {
							children: (
								<div className="grid grid-cols-2 gap-x-6 flex-1 py-2">
									<div className="text-gray-500">{field?.label}</div>
									<div>{field?.value}</div>
								</div>
							),
						};
					})}
			/>
		</BaseDraggableWidget>
	);
};

export default AssetOverview;
